window.idcVersion = APP_VERSION_NAME;
window.idcBuildNumber = APP_BUILD_NUMBER;
window.idcInstallSource = APP_INSTALL_SOURCE;
